let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("fr8OK")).then(() => parcelRequire('55Xut'));